const PRIVATE = `
-----BEGIN RSA PRIVATE KEY-----
MIICXwIBAAKBgQtR0rZqp48C4JC59dTxMDe6VEd50uz1ph3nay60LMjaJJ/zmPx+
OgzYaRRHI2qLzqFZE1rS85uZ3plSFNKfoVG5zY5ZS7NRJ+vsaYASPFHcDbSY2iAr
2SEMrJD1ZCRPC50UG6BD/02/Uz1MiJvzS+YX0sMFca54Xh54LvUcQ+3DuQIDAQAB
AoGBBDNY/liV1Xw72XkowNzAB+4dWGjc3RJLks1N+Qbjl6Vb8f9zxj8RS7MDS4Ma
oW9APp/PjuS5ggSXlk3fbEnQk4DgIgTrIEl2ISz96WHe2AvRjT0wb1/kCox2eeDn
3rFlFYjZ+g2gjJnJLN7/ggO7xj1VVHuaThZRRfWsW9BwzAwBAkEDfChywJsi73JD
5uZYD1uA3hZwypy+RP2gF6F71UnbhYK114jcvKs6t7UbWIFAX/3FK7alRLIg7ey1
xqPyYmJkpwJBAz+D04qz6/at1f5Sp+ZKHh3Wlz4zwu6jllbjxq0sX/J+Q33/aFPf
4gU6+CGcAxz7QjGjxsHElm85GMh4RV6MwJ8CQQCmvwSbnSNNb6TjTiAdVrPiTn1s
URl62ZCHeiYj+jbuYDzOeQUQukwyM8ZVp2q5xjuI7Q08prJi5cAfzVqrKsq3AkEB
/9KRH8tn70tJcWZHWwU8THmOVwddca7YF1vVKzspRAZcXO4dtaMVaMrHeUii0fAG
6q845ISxZHzsuFjvuidBWQJBAu3D28LKJBv87WazG6M7ogOwFKhtyDphAoeT9q/o
nnSisIWx+lGRSgCaSVne+SpbcUXI5c0ye2oTcL7Z7VC66OA=
-----END RSA PRIVATE KEY-----
`;

const PUBLIC = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQmsitEPMGmjPFbhjU0yUm2+6Xjf
/YzjBzJP2Dv7VaZABuJMptX8LGLUo/YoREmJkA6Bfv7267dJskCST29Ea1C7ftlC
dcheCSkwz150tmRcrEMnP7ZqSqowPK+vlTPVK6xW7LYF7o00Z4xh5OXkjRobp2o+
SfTVFZwmp0hLVLaP4QIDAQAB
-----END PUBLIC KEY-----
`;

export {
    PRIVATE,
    PUBLIC
};